import Vue from 'vue'
import Router from 'vue-router'

import LandingPage from "./components/landing/landing-layout.vue";
import ComerciosPage from "./components/landing/comercio.mapa.vue";

let misRutas = [];
misRutas = [
    { 
        path: '/', 
        component: LandingPage,
        meta: {}
    },
    { 
      path: '/comercios', 
      component: ComerciosPage,
      meta: {}
  }
  ];


Vue.use(Router)

const router = new Router({
//   mode: 'history',
  base: process.env.BASE_URL,
  routes: misRutas
})

export default router;
